import React, {Fragment} from 'react';
import createForm from "./Form";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import Select from "../../form/Select";
import Modal from "../../layout/Modal";
import {
    CurrencyFormatter,
    DateFormatter,
    optionsTemplate,
    ProductColumn,
    ProductName,
    ProductSelect
} from "../../../utils/formatters";
import Icon from "../../form/Icon";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import {PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE, PAYMENT_PRICE_TYPE_UNIT_NET_PRICE, Price} from "../../classes/Price";
import Invoice from "../OperationList/Elements/Invoice";
import get from "../../../utils/get";
import Payment from "../OperationList/Elements/Payment";
import Confirm from "../../form/Confirm";

class ProductionExpensesPaymentForm extends React.Component {

    state = {
        production: null,
        expense_type: null,
        vat: null,
        paging: null
    };

    getValue = (name) => {
        return get(this.props.values, name, undefined);
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        if (!props.disabled) {
            const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
            props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
            if (this.props[name]) {
                props = {
                    ...this.props[name],
                    ...props,
                    disabled: this.props[name].disabled || props.disabled
                };
            }
        }
        return props;
    }

    render() {
        return (
            <Fragment>
                {this.state.production && <Modal
                    header="Hozzáadás"
                    state="on"
                    buttons={[
                        {
                            text: "Ok",
                            props: {
                                color: "primary",
                                disabled: this.props.loading || !this.state.expense_type || !this.state.vat
                            },
                            onClick: async (e) => {
                                this.props.setFieldValue("items", {...this.props.values.items, [this.state.production.id + "" + this.state.expense_type.id + "" + this.state.vat.id]: {expense_type: this.state.expense_type, production: this.state.production, vat: this.state.vat}});
                                this.setState({production: null});
                            }
                        },
                        {
                            text: "Mégse",
                            props: {
                                color: "default",
                                disabled: this.props.loading
                            },
                            onClose: true,
                            onClick: async () => {
                                this.setState({production: null});
                            }
                        }
                    ]}
                >
                    <div className="form-group">
                        <Select
                            component="ExpenseType"
                            storeType="local"
                            label="Jogcím"
                            value={this.state.expense_type}
                            view={["name"]}
                            saveChanges={(field, expense_type) => {
                                this.setState({expense_type});
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <Select
                            component="vatrate"
                            filter={{field: "active", value: 1}}
                            storeType="local"
                            label="Áfa"
                            value={this.state.vat}
                            view={["name","rate"]}
                            saveChanges={(field, vat) => {
                                this.setState({vat});
                            }}
                        />
                    </div>
                </Modal>}
                <form onSubmit={this.props.handleSubmit}>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <Select
                                label="Partner"
                                name="seller"
                                component="partner"
                                labelKey="name"
                                valueKey="partner_id"
                                storeType="remote"
                                optionsTemplate={optionsTemplate("partner")}
                                {...this.props.getFieldProps("seller")}
                                value={this.props.values.seller}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    {!this.props.values[this.props.componentConfig.idfield] && <div className="row">
                        <Payment props={{values: this.props.values, getFieldProps: this.getProps, getProps: this.getProps, getValue: this.getValue, setFieldValue: this.props.setFieldValue}} />
                    </div>}
                    {!this.props.values[this.props.componentConfig.idfield] && <Invoice props={{values: this.props.values, getProps: this.getProps, getValue: this.getValue, setFieldValue: this.props.setFieldValue}} default="seller"/>}
                    <div className="row form-row">
                        <div className="col-md-12">
                            <SelectorGrid
                                ref={(el) => this.items = el}
                                component="ProductionExpense"
                                onPage={(paging) => {
                                    this.setState({paging});
                                }}
                                onItemUpdate={async (newItem, oldItem, fieldName, rowIndex, {rowOffset}) => {
                                    const items = {...this.props.values.items};
                                    let amount = null;
                                    if (fieldName === "net_amount") {
                                        amount = new Price({net: newItem[fieldName], qty: 1, vatrate: newItem.vat.rate}, PAYMENT_PRICE_TYPE_UNIT_NET_PRICE);
                                    } else if (fieldName === "amount") {
                                        amount = new Price({gross: newItem[fieldName], qty: 1, vatrate: newItem.vat.rate}, PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE);
                                    }
                                    if (amount) {
                                        newItem.net_amount = amount.getPrice(PAYMENT_PRICE_TYPE_UNIT_NET_PRICE);
                                        newItem.amount = amount.getPrice(PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE);
                                    }
                                    items[Object.keys(items)[rowOffset]] = {...newItem};
                                    await this.props.setFieldValue("items", items);
                                    this.items && this.items.loadDataBackground(null, this.state.paging, null);
                                }}
                                filter={{field: "id", operator: "isnull"}}
                                addRow={!this.props.values[this.props.componentConfig.idfield] && <Select
                                    storeType="remote"
                                    component="Production"
                                    placeholder="Gyártás hozzáadása"
                                    objectValue={true}
                                    order={{field: "productiondate", direction: "desc"}}
                                    view={["product.displayname", "product.id", "productiondate", ...ProductSelect.view.map((v) => "product." + v)]}
                                    valueKey="id"
                                    optionsTemplate={(option) => {
                                        return <Fragment><ProductSelect {...option.product} /><b>Gyártás dátuma: {DateFormatter(option.productiondate)}</b></Fragment>;
                                    }}
                                    selectedOptionTemplate={(option) => {
                                        return <Fragment><ProductSelect {...option.product} /><b>Gyártás dátuma: {DateFormatter(option.productiondate)}</b></Fragment>;
                                    }}
                                    label={false}
                                    openIfHasOptions={true}
                                    saveChanges={(field, production) => {
                                        this.setState({production});
                                    }}
                                />}
                                columns={{
                                    ...(!this.props.values[this.props.componentConfig.idfield] ? {"action": {
                                        header: ' ',
                                        width: 1,
                                        renderer: (value, rowData, rowIndex, {rowOffset}) => {
                                            return !this.props.values[this.props.componentConfig.idfield] && <Confirm
                                                onAccept={(e) => {
                                                    e && e.preventDefault();
                                                    const items = {...this.props.values.items};
                                                    delete items[Object.keys(items || {})[rowOffset]];
                                                    this.props.setFieldValue("items", items);
                                                }}
                                                color="danger"
                                                icon={{lib: "fa", name: "trash"}}
                                                className="btn-xs"
                                                header="Törlés"
                                                body="Biztosan törlöd ezt a tételt?"
                                                acceptButton="Törlés"
                                            />
                                        }
                                    }} : {}),
                                    "production.product.displayname": {
                                        ...ProductColumn("production.product.id"),
                                        width: 4,
                                    },
                                    "expense_type.name": {
                                        header: "Jogcím",
                                        width: 4
                                    },
                                    "net_amount": {
                                        header: "Nettó",
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                        width: 2,
                                        editor:
                                            (parent) =>
                                                (props, value) =>
                                                    <TextInput type="decimal" name="net_amount" label={false} focus="focus"
                                                               value={value}
                                                               onKeyDown={(e, field, value) => {
                                                                   ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                               }}
                                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                    },
                                    "vat.name": {
                                        header: "Áfa",
                                        className: "nowrap"
                                    },
                                    "amount": {
                                        header: "Bruttó",
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                        width: 2,
                                        editor:
                                            (parent) =>
                                                (props, value) =>
                                                    <TextInput type="decimal" name="amount" label={false} focus="focus"
                                                               value={value}
                                                               onKeyDown={(e, field, value) => {
                                                                   ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                               }}
                                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                    }
                                }}
                                aggregations={{
                                    fields: {
                                        net_amount: {},
                                        amount: {}
                                    }
                                }}
                                value={{
                                    items: Object.keys(this.props.values.items || {}).map((k) => this.props.values.items[k]),
                                    aggregations: [{net_amount: Object.keys(this.props.values.items || {}).map((k) => this.props.values.items[k].net_amount).reduce((sum, price) => parseFloat(sum || "0") + parseFloat(price || "0"), 0), amount: Object.keys(this.props.values.items || {}).map((k) => this.props.values.items[k].amount).reduce((sum, price) => parseFloat(sum || "0") + parseFloat(price || "0"), 0)}]
                                }}
                            />
                        </div>
                    </div>
                </form>
            </Fragment>
        );
    }
}

export default createForm(ProductionExpensesPaymentForm);
